import { cn } from "@/lib/utils";
import { KPI_STATUS } from "@/lib/constants";

export function KPIStatusPill({ status, testid }) {
  const m = KPI_STATUS[status] || KPI_STATUS.on_track;
  return (
    <span data-testid={testid} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", m.cls)}>
      {m.label}
    </span>
  );
}

export function KPIProgressRow({ row, onClick }) {
  const m = KPI_STATUS[row.status] || KPI_STATUS.on_track;
  const pct = Math.min(row.pct || 0, 100);
  return (
    <div role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => e.key === "Enter" && onClick?.()} className="-mx-2 cursor-pointer space-y-1 rounded-lg px-2 py-1.5 transition-colors hover:bg-sky-50/70" data-testid={`kpi-row-${row.user_id}`}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-600">{row.user_name || "Unknown"}</span>
        <span className="flex items-center gap-2">
          <span className="font-semibold tabular-nums text-slate-800">{row.actual}/{row.target}</span>
          <KPIStatusPill status={row.status} testid={`kpi-status-${row.user_id}`} />
        </span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
        <div className={cn("h-full rounded-full transition-all", m.bar)} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export function kpiSummary(k) {
  const per = { Weekly: "week", Monthly: "month", Quarterly: "quarter", Yearly: "year", Annual: "year" }[k.period] || (k.period || "").toLowerCase();
  return `Target ${k.target} per ${per}`;
}
